import { render, staticRenderFns } from "./Webinari.vue?vue&type=template&id=6c5be98e&scoped=true&"
import script from "./Webinari.vue?vue&type=script&lang=js&"
export * from "./Webinari.vue?vue&type=script&lang=js&"
import style0 from "./Webinari.vue?vue&type=style&index=0&id=6c5be98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5be98e",
  null
  
)

export default component.exports